var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useMemo, useState, } from 'react';
import { Grommet } from 'grommet';
import { useTheme as useStyledComponentsTheme } from 'styled-components';
import { deepMerge } from 'grommet/utils';
import { theme as defaultTheme } from '../theme/theme';
import { themes } from '../theme/themes';
export var THEME_EXTENSION_KEY = "themeExtension";
export var THEME_MODE_KEY = "themeMode";
export var useTheme = function () { return useStyledComponentsTheme(); };
export var ThemeModeContext = createContext({
    mode: (typeof window !== "undefined"
        ? window.localStorage.getItem(THEME_MODE_KEY)
        : undefined) || "light",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleMode: function () { },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
    setTheme: function (index) { },
});
export var ThemeProvider = function (_a) {
    var children = _a.children;
    var _b = useState("light"), mode = _b[0], setThemeMode = _b[1];
    var _c = useState(themes[0]), theme = _c[0], setThemeExtension = _c[1];
    var setTheme = useCallback(function (index) {
        window.localStorage.setItem(THEME_EXTENSION_KEY, index.toString());
        setThemeExtension(themes[index]);
    }, []);
    // eslint-disable-next-line no-shadow
    var setMode = useCallback(function (mode) {
        window.localStorage.setItem(THEME_MODE_KEY, mode);
        setThemeMode(mode);
    }, []);
    var toggleMode = useCallback(function () {
        if (mode === "light") {
            setMode("dark");
        }
        else {
            setMode("light");
        }
    }, [mode, setMode]);
    var providerValue = useMemo(function () { return ({ mode: mode, toggleMode: toggleMode, setTheme: setTheme }); }, [mode, toggleMode, setTheme]);
    useEffect(function () {
        var localTheme = window.localStorage.getItem(THEME_EXTENSION_KEY);
        if (localTheme) {
            setThemeExtension(themes[parseInt(localTheme, 10)]);
        }
    }, []);
    useEffect(function () {
        var localTheme = window.localStorage.getItem(THEME_MODE_KEY);
        if (window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches &&
            !localTheme) {
            setMode("dark");
        }
        else if (localTheme) {
            setThemeMode(localTheme);
        }
        else {
            setMode("light");
        }
    }, [setMode]);
    return (_jsx(Grommet, __assign({ full: true, theme: deepMerge(defaultTheme, theme), themeMode: mode, 
        // TODO: Define this in the theme package
        background: {
            dark: "dark-1",
            light: "light-3",
        } }, { children: _jsx(ThemeModeContext.Provider, __assign({ value: providerValue }, { children: children })) })));
};
ThemeProvider.defaultProps = {
    children: null,
};
//# sourceMappingURL=ThemeProvider.js.map